export default {
  en: {
    comprehensiveAnalyticsPage: {
      loading: "Loading comprehensive analytics...",
      title: "Comprehensive Analytics",
      subtitle: "Real-time insights and performance metrics",
      updated: "Updated: {{time}}",
      timeRange: "Time Range",
      last24h: "Last 24h",
      last7d: "Last 7 days",
      last14d: "Last 14 days",
      last30d: "Last 30 days",
      electionType: "Election Type",
      allElections: "All Elections",
      presidential: "Presidential",
      parliamentary: "Parliamentary",
      council: "Council",
      senatorial: "Senatorial",
      regional: "Regional",
      refresh: "Refresh",
      tabOverview: "Overview",
      tabUsers: "Users",
      tabSubmissions: "Submissions",
      tabGeographic: "Geographic",
      tabOperations: "Operations",
      tabReports: "Reports",
      totalUsers: "Total Users",
      activeCount: "{{count}} active",
      totalSubmissions: "Total Submissions",
      perDayAvg: "{{count}}/day avg",
      pendingQueue: "Pending Queue",
      approvalRate: "Approval Rate",
      trendVsLastWeek: "+5% vs last week",
      coverage: "Coverage",
      regionsCount: "{{count}} regions",
      corrections: "Corrections",
      verificationStatusDistribution: "Verification Status Distribution",
      submissionTrends: "Submission Trends",
      pending: "Pending",
      approved: "Approved",
      certified: "Certified",
      rejected: "Rejected",
      correction: "Correction",
      approvedResults: "Approved Results",
      certifiedResults: "Certified Results",
      awaitingReview: "Awaiting Review",
      activeUsers: "Active Users",
      lastNDays: "Last {{count}} days",
      topSubmitters: "Top Submitters",
      usersByRole: "Users by Role",
      noUserData: "No user data available",
      activityByHour: "Activity by Hour",
      userRegistrationPatterns: "User registration patterns",
      noActivityData: "No activity data available",
      mostActiveAgents: "Most active field agents",
      agent: "Agent",
      email: "Email",
      submissions: "Submissions",
      lastActive: "Last Active",
      noSubmissionData: "No submission data available",
      totalVotes: "Total Votes",
      peakHour: "Peak Hour",
      notAvailable: "N/A",
      submissionsCount: "{{count}} submissions",
      dailyAverage: "Daily Average",
      dailySubmissions: "Daily Submissions",
      votes: "Votes",
      byElectionType: "By Election Type",
      noElectionTypeData: "No election type data",
      agentPerformance: "Agent Performance",
      agentPerformanceDesc: "Submissions and approval rates by agent",
      approvalPct: "Approval %",
      noAgentPerformance: "No agent performance data",
      overallCoverage: "Overall Coverage",
      regionsReported: "Regions Reported",
      ofTotal: "of 10 total",
      underreported: "Underreported",
      regionsBelow50: "regions < 50%",
      regionalCoverage: "Regional Coverage",
      coveragePct: "Coverage %",
      noCoverageData: "No coverage data available",
      underreportedAreas: "Underreported Areas",
      underreportedDesc: "Regions with less than 50% coverage",
      submissionsOfExpected: "{{submissions}} of {{expected}} expected submissions",
      allRegionsAdequate: "All regions have adequate coverage!",
      regionalDetails: "Regional Details",
      region: "Region",
      expected: "Expected",
      systemHealth: "System Health",
      unknown: "Unknown",
      database: "Database",
      apiServer: "API Server",
      websocket: "WebSocket",
      lastCheck: "Last check: {{time}}",
      pendingVerification: "Pending Verification",
      awaitingCorrection: "Awaiting Correction",
      submissionsLastHour: "Submissions (Last Hour)",
      queueStatus: "Queue Status",
      disputed: "Disputed",
      totalQueue: "Total Queue",
      recentActivity: "Recent Activity",
      noRecentActivity: "No recent activity",
      dataStoreStatus: "Data Store Status",
      exportData: "Export Data",
      exportDesc: "Download analytics data in various formats",
      byDataType: "By Data Type",
      fullExport: "Full Export",
      fullExportDesc: "Export all analytics data in a single file",
      dataTypes: {
        users: "users",
        submissions: "submissions",
        verification: "verification",
        geographic: "geographic",
        operations: "operations"
      }
    }
  },
  fr: {
    comprehensiveAnalyticsPage: {
      loading: "Chargement des analyses complètes...",
      title: "Analyses complètes",
      subtitle: "Informations en temps réel et indicateurs de performance",
      updated: "Mis à jour : {{time}}",
      timeRange: "Période",
      last24h: "Dernières 24 h",
      last7d: "7 derniers jours",
      last14d: "14 derniers jours",
      last30d: "30 derniers jours",
      electionType: "Type d'élection",
      allElections: "Toutes les élections",
      presidential: "Présidentielle",
      parliamentary: "Législatives",
      council: "Municipales",
      senatorial: "Sénatoriales",
      regional: "Régionales",
      refresh: "Actualiser",
      tabOverview: "Aperçu",
      tabUsers: "Utilisateurs",
      tabSubmissions: "Soumissions",
      tabGeographic: "Géographie",
      tabOperations: "Opérations",
      tabReports: "Rapports",
      totalUsers: "Total des utilisateurs",
      activeCount: "{{count}} actifs",
      totalSubmissions: "Total des soumissions",
      perDayAvg: "{{count}}/jour en moy.",
      pendingQueue: "File d'attente",
      approvalRate: "Taux d'approbation",
      trendVsLastWeek: "+5 % vs semaine dernière",
      coverage: "Couverture",
      regionsCount: "{{count}} régions",
      corrections: "Corrections",
      verificationStatusDistribution: "Répartition des statuts de vérification",
      submissionTrends: "Tendances des soumissions",
      pending: "En attente",
      approved: "Approuvé",
      certified: "Certifié",
      rejected: "Rejeté",
      correction: "Correction",
      approvedResults: "Résultats approuvés",
      certifiedResults: "Résultats certifiés",
      awaitingReview: "En attente de révision",
      activeUsers: "Utilisateurs actifs",
      lastNDays: "{{count}} derniers jours",
      topSubmitters: "Meilleurs contributeurs",
      usersByRole: "Utilisateurs par rôle",
      noUserData: "Aucune donnée d'utilisateur disponible",
      activityByHour: "Activité par heure",
      userRegistrationPatterns: "Tendances d'inscription des utilisateurs",
      noActivityData: "Aucune donnée d'activité disponible",
      mostActiveAgents: "Agents de terrain les plus actifs",
      agent: "Agent",
      email: "E-mail",
      submissions: "Soumissions",
      lastActive: "Dernière activité",
      noSubmissionData: "Aucune donnée de soumission disponible",
      totalVotes: "Total des votes",
      peakHour: "Heure de pointe",
      notAvailable: "N/D",
      submissionsCount: "{{count}} soumissions",
      dailyAverage: "Moyenne quotidienne",
      dailySubmissions: "Soumissions quotidiennes",
      votes: "Votes",
      byElectionType: "Par type d'élection",
      noElectionTypeData: "Aucune donnée par type d'élection",
      agentPerformance: "Performance des agents",
      agentPerformanceDesc: "Soumissions et taux d'approbation par agent",
      approvalPct: "Approbation %",
      noAgentPerformance: "Aucune donnée de performance des agents",
      overallCoverage: "Couverture globale",
      regionsReported: "Régions ayant rapporté",
      ofTotal: "sur 10 au total",
      underreported: "Sous-déclarées",
      regionsBelow50: "régions < 50 %",
      regionalCoverage: "Couverture régionale",
      coveragePct: "Couverture %",
      noCoverageData: "Aucune donnée de couverture disponible",
      underreportedAreas: "Zones sous-déclarées",
      underreportedDesc: "Régions avec moins de 50 % de couverture",
      submissionsOfExpected: "{{submissions}} sur {{expected}} soumissions attendues",
      allRegionsAdequate: "Toutes les régions ont une couverture adéquate !",
      regionalDetails: "Détails régionaux",
      region: "Région",
      expected: "Attendu",
      systemHealth: "État du système",
      unknown: "Inconnu",
      database: "Base de données",
      apiServer: "Serveur API",
      websocket: "WebSocket",
      lastCheck: "Dernière vérification : {{time}}",
      pendingVerification: "Vérification en attente",
      awaitingCorrection: "Correction en attente",
      submissionsLastHour: "Soumissions (dernière heure)",
      queueStatus: "État de la file d'attente",
      disputed: "Contesté",
      totalQueue: "Total de la file",
      recentActivity: "Activité récente",
      noRecentActivity: "Aucune activité récente",
      dataStoreStatus: "État du stockage des données",
      exportData: "Exporter les données",
      exportDesc: "Téléchargez les données d'analyse dans différents formats",
      byDataType: "Par type de données",
      fullExport: "Export complet",
      fullExportDesc: "Exportez toutes les données d'analyse dans un seul fichier",
      dataTypes: {
        users: "utilisateurs",
        submissions: "soumissions",
        verification: "vérification",
        geographic: "géographie",
        operations: "opérations"
      }
    }
  }
};
